module.exports = __webpack_public_path__ + "static/media/PIP.26319ee3.png";